import Account from '@/pages/Account/Template'
import Sellpoint from '@/pages/Account/Sellpoint'
import Settings from '@/pages/Account/Settings'
export default {
    path: '',
    component: Account,
    children: [
      {
        path: '/account',
        name: 'Account',
        component: Account,
      },
      {
        path: '/account/business',
        name: 'AccountSellpoint',
        component: Sellpoint,
      },
      {
        path: '/account/settings',
        name: 'Settings',
        component: Settings,
      },
    ]
}


// import Account from '@/pages/Account'


// export default {
//   path: '/account',
//   component: Account,
//   children: [
//     // {
//     //   path: 'createcc',
//     //   name: 'CreateSellpoint',
//     //   component: CreateSellpoint
//     // },
//   ]
// }


// WEBPACK FOOTER //
// ./src/router/account.js